import Vue from "vue";
import VueCompositionApi from "@vue/composition-api";
// import BootstrapVue from "bootstrap-vue";
import { ToastPlugin, BModal, VBModal, BButton } from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import { library } from "@fortawesome/fontawesome-svg-core";

// import { hbContract } from "@/icons/contract"

import {
  faAddressCard,
  faArchive,
  faArrowDown,
  faArrowUp,
  faBolt,
  faBalanceScale,
  faCalendar,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronCircleRight,
  faChevronUp,
  faCircle,
  faClipboard,
  faCog,
  faCopy,
  faCube,
  faCubes,
  faDollarSign,
  faEdit,
  faEllipsisH,
  faFile,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faHistory,
  faInfo,
  faMap,
  faMapMarked,
  faPaperclip,
  faPhone,
  faPlus,
  faPrint,
  faSearch,
  faSeedling,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faStickyNote,
  faTasks,
  faTimes,
  faTractor,
  faTrashAlt,
  faTruckMoving,
  faUser,
  faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { session } from "@/utilities/session";
import { JSConn } from "@/utilities/js-conn";

// Vue.config.productionTip = false;
library.add(
  faAddressCard,
  faArchive,
  faArrowDown,
  faArrowUp,
  faBalanceScale,
  faBolt,
  faCalendar,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronCircleRight,
  faChevronUp,
  faCircle,
  faClipboard,
  faCog,
  faCopy,
  faCube,
  faCubes,
  faDollarSign,
  faEdit,
  faEllipsisH,
  faFile,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faHistory,
  faInfo,
  faMap,
  faMapMarked,
  faPaperclip,
  faPhone,
  faPlus,
  faPrint,
  faSearch,
  faSeedling,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faStickyNote,
  faTasks,
  faTimes,
  faTractor,
  faTrashAlt,
  faTruckMoving,
  faUser,
  faWindowClose,
  farCircle,
);

Vue.use(VueCompositionApi);

Vue.component("font-awesome-icon", FontAwesomeIcon);

// Vue.use(BootstrapVue);
Vue.use(ToastPlugin);
Vue.component("b-modal", BModal);
Vue.directive("b-modal", VBModal);
Vue.component("b-button", BButton);

import "@/styles/global.scss";

const jsConn = new JSConn();
jsConn.fromRoutePath = router.currentRoute.path;
jsConn.toRoutePath = store.getters.nextPath;

session
  .updateSession(jsConn)
  .catch(() => {})
  .finally(() => {
    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount("#app");
  });
